import React from "react";
import { withAppState } from "../../state";
import { ScreenWrapper, Title, MessageBox, ActionButton } from "./styles/Styled";
import { i18n } from "../../services/i18nService";

class GoToStarzplay extends React.Component {
  constructor(props) {
    super(props);
    this.actionButtonRef = React.createRef();
    this.onBack = this.onBack.bind(this);
  }

  OpenAppHandler = () => {
    if (window.webOSDev) {
      window.webOSDev.launch(
        {
          id: "com.webos.app.discovery" //id of Content Store LG smart tv
        },
        function(inResponse) {
          if (inResponse.success) {
            console.log("Launched");
          } else {
            window.close();
          }
        }
      );
    }
  };

  handleKeyDown = event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      this.OpenAppHandler();
    }
  };

  componentDidMount() {
    this.props.onRef(this);
    if (this.actionButtonRef.current) {
      this.actionButtonRef.current.focus();
    }
  }

  onBack() {
    return true;
  }

  render() {
    return (
      <>
        <ScreenWrapper>
          <Title>{i18n.get("pages.migrate.gotoTitle")}</Title>

          <MessageBox>{i18n.get("pages.migrate.msgBox")}</MessageBox>

          <ActionButton
            ref={this.actionButtonRef}
            tabIndex={0}
            onClick={this.OpenAppHandler}
            onKeyDown={this.handleKeyDown}
          >
            {i18n.get("pages.migrate.buttonLabel")}
          </ActionButton>
        </ScreenWrapper>
      </>
    );
  }
}

export default withAppState(GoToStarzplay);
